import { createEdgeSpark } from "@edgespark/client";

const WORKER_URL = "https://staging--bq3ffjcdhdlfa8wgbhjg.youbase.cloud";

export const edgeClient = createEdgeSpark({ baseUrl: WORKER_URL });
